// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disclosureIcp[data-v-11817b0c] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  font-size: 14px;\n  color: #337fff;\n}\n.disclosureIcp span[data-v-11817b0c] {\n  margin: 0 10px;\n}\n.disclosureIcp .line[data-v-11817b0c] {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
